import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthenticationContainer } from 'entities/Authentication';
import { Flex, Typography } from 'shared/_ui';
import { getValidatedTelegramBotUrl } from 'shared/consts/telegram';
import styles from './styles.module.scss';

// A provider browser return carries no proof of payment or account identity.
// Authoritative payment confirmation remains with the backend and the bot.
export const PaymentReturnPage: React.FC = () => {
  const { t } = useTranslation();
  const telegramBotUrl = getValidatedTelegramBotUrl();

  return (
    <AuthenticationContainer title={t('paymentReturn.title')}>
      <Flex direction="column" spacing={20}>
        <Typography.Text>{t('paymentReturn.description')}</Typography.Text>
        <Typography.Text type="secondary">{t('paymentReturn.sameAccount')}</Typography.Text>
        {telegramBotUrl ? (
          <a
            className={styles.botAction}
            href={telegramBotUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('paymentReturn.botAction')}
          </a>
        ) : (
          <Typography.Text type="secondary">{t('paymentReturn.botUnavailable')}</Typography.Text>
        )}
      </Flex>
    </AuthenticationContainer>
  );
};
